import React, { useState, useEffect } from "react";
import axios from "axios";
import { url } from "../../../../../../../../../App";
import { useBorrowerContext } from "../../../../../../store/borrower-details";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from "js-cookie";
import { ToastContainer } from "react-toastify";
import "./Deduped.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useParams } from "react-router";

const Deduped = () => {
  const [open, setOpen] = React.useState(false);
  const { borrowerData } = useBorrowerContext();
  const fetchedBorrowerDetails = borrowerData.borrower;
  const [showTable, setShowTable] = useState(false);
  const [showButton, setShowButton] = useState(false);
  // console.log(fetchedBorrowerDetails)
  const [isWaiting, setIsWaiting] = useState(false);
  const [duplicates, setDuplicates] = useState({
    name: {},
    fatherName: {},
    mobile: {},
    location: {},
    address: {},
  });
  const [createdBy, setCreatedBy] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [createdTime, setCreatedTime] = useState("");
  const [activeTable, setActiveTable] = useState("borrower");
  const { loanid } = useParams();
  const fetchedLoanDetails = borrowerData.loan;
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);
  const [isDisbursed, setIsDisbursed] = useState(false);
  console.log(isDisbursed)

  useEffect(() => {
    if (loanid) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

  const fetchData = async () => {
    if (!fetchedBorrowerDetails?.borrower_uniqueno) return;
    setOpen(true);
    try {
      const dedupeRes = await axios.post(url + "/api/get/dedupeddata", {
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
        borrower_uniqueno: fetchedBorrowerDetails?.borrower_uniqueno,
      });
      // console.log(dedupeRes, "dedupeRes")

      if (dedupeRes.data.auth) {
        const duplicateData = dedupeRes.data.data.duplicates;
        setDuplicates({
          name: duplicateData.name,
          fatherName: duplicateData.fatherName,
          mobile: duplicateData.mobile,
          location: duplicateData.location,
          address: duplicateData.address,
        });
        setCreatedBy(dedupeRes.data.data.customer_Name);
        setCreatedDate(dedupeRes.data.data.created_date);
        setCreatedTime(dedupeRes.data.data.created_time);
        setShowTable(true);
        setShowButton(true);
      } else {
        setShowTable(false);
        setShowButton(false);
      }
    } catch (err) {
      console.error("Error fetching dedupe data:", err);
      setShowTable(false);
      setShowButton(false);
    } finally {
      setOpen(false);
    }
  };

  useEffect(() => {
    fetchData();
    //eslint-disable-next-line
  }, []);

  const handleInitiateDeduped = async () => {
    if (!fetchedBorrowerDetails?.borrower_uniqueno) return;
    // setOpen(true);
    setIsWaiting(true);
    try {
      const {
        borrower_uniqueno,
        borrower_firstname,
        borrower_middlename,
        borrower_lastname,
        borrower_fathername,
        borrower_mobile,
        borrower_applicant_family_details,
        borrower_references_details,
        borrower_current_address,
        borrower_permanent_address,
      } = fetchedBorrowerDetails;

      const token = Cookies.get("Token");
      const email = Cookies.get("Email");

      const namePayload = {
        token,
        email,
        borrower_uniqueno,
        borrower_firstname,
        borrower_middlename,
        borrower_lastname,
      };

      const fatherPayload = {
        token,
        email,
        borrower_uniqueno,
        borrower_fathername,
      };

      const mobilePayload = {
        token,
        email,
        borrower_uniqueno,
        borrower_mobile,
        borrower_applicant_family_details,
        borrower_references_details,
      };

      const locationPayload = {
        token,
        email,
        mobileNumber: borrower_mobile,
        borrower_uniqueno,
      };

      const addressPayload = {
        token,
        email,
        borrower_uniqueno,
        borrower_current_address,
        borrower_permanent_address,
      };

      const results = await Promise.allSettled([
        axios.post(url + "/api/duplicate/name", namePayload),
        axios.post(url + "/api/duplicate/fathername", fatherPayload),
        axios.post(url + "/api/duplicate/mobile", mobilePayload),
        axios.post(url + "/api/duplicate/location", locationPayload),
        axios.post(url + "/api/duplicate/address", addressPayload),
      ]);
      // console.log(results, "results")

      const extractDuplicates = (result) => {
        if (result.status !== "fulfilled") return {};
        const data = result.value.data;
        return {
          duplicate_borrower_uniquenos: data.duplicate_borrower_uniquenos || [],
          duplicate_coapplicant_ids: data.duplicate_coapplicant_ids || [],
        };
      };

      const extractMobileDuplicates = (result) => {
        if (result.status !== "fulfilled") return {};
        const data = result.value.data;
        return {
          duplicate_borrower_uniquenos:
            data.mobile?.duplicate_borrower_uniquenos || [],
          duplicate_family_uniquenos:
            data.mobile?.duplicate_family_uniquenos || [],
          duplicate_reference_uniquenos:
            data.mobile?.duplicate_reference_uniquenos || [],
          duplicate_coapplicant_ids:
            data.mobile?.duplicate_coapplicant_ids || [],
        };
      };

      const duplicateData = {
        name: extractDuplicates(results[0]),
        fatherName: extractDuplicates(results[1]),
        mobile: extractMobileDuplicates(results[2]),
        location: extractDuplicates(results[3]),
        address: extractDuplicates(results[4]),
      };
      setDuplicates(duplicateData);
      await axios.post(url + "/api/duplicate/save", {
        token,
        email,
        borrower_uniqueno: fetchedBorrowerDetails.borrower_uniqueno,
        duplicates: duplicateData,
      });
      setShowTable(true);
      setShowButton(true);
      fetchData();
      // setOpen(false);
    } catch (error) {
      // setOpen(false);
      console.log("Error calling duplicate check APIs:", error);
    } finally {
      // setOpen(false);
      setIsWaiting(false);
    }
  };

  // const readableCriteria = {
  //     name: 'Name',
  //     fatherName: 'Father Name',
  //     mobile: 'Mobile Number',
  //     location: 'Location',
  //     address: 'Address',
  // };

  const getMatchType = (id, field) => {
    const sources = [];
    if (field === "mobile") {
      if (duplicates[field]?.duplicate_borrower_uniquenos?.includes(id))
        sources.push("Borrower");
      if (duplicates[field]?.duplicate_family_uniquenos?.includes(id))
        sources.push("Family");
      if (duplicates[field]?.duplicate_reference_uniquenos?.includes(id))
        sources.push("Reference");
      if (duplicates[field]?.duplicate_coapplicant_ids?.includes(id))
        sources.push("Coapplicant");
      return sources.length ? sources.join(" / ") : "NA";
    }

    if (duplicates[field]?.duplicate_borrower_uniquenos?.includes(id))
      sources.push("Borrower");
    if (duplicates[field]?.duplicate_coapplicant_ids?.includes(id))
      sources.push("Coapplicant");
    return sources.length ? sources.join(" / ") : "NA";
  };

  const handleDownloadExcel = () => {
    const fields = ["name", "fatherName", "mobile", "location", "address"];

    const getMatchType = (id, field) => {
      const sources = [];

      if (field === "mobile") {
        if (duplicates[field]?.duplicate_borrower_uniquenos?.includes(id))
          sources.push("Borrower");
        if (duplicates[field]?.duplicate_family_uniquenos?.includes(id))
          sources.push("Family");
        if (duplicates[field]?.duplicate_reference_uniquenos?.includes(id))
          sources.push("Reference");
        if (duplicates[field]?.duplicate_coapplicant_ids?.includes(id))
          sources.push("Coapplicant");
        return sources.length ? sources.join(" / ") : "NA";
      }

      if (duplicates[field]?.duplicate_borrower_uniquenos?.includes(id))
        sources.push("Borrower");
      if (duplicates[field]?.duplicate_coapplicant_ids?.includes(id))
        sources.push("Coapplicant");
      return sources.length ? sources.join(" / ") : "NA";
    };

    const generateData = (type) => {
      const idSet = new Set();

      fields.forEach((field) => {
        const ids =
          type === "borrower"
            ? duplicates[field]?.duplicate_borrower_uniquenos || []
            : duplicates[field]?.duplicate_coapplicant_ids || [];
        ids.forEach((id) => idSet.add(id));
      });

      const data = [];
      Array.from(idSet).forEach((id, index) => {
        const row = {
          "Sr No": index + 1,
          "Borrower ID": id,
          Name: getMatchType(id, "name"),
          "Father Name": getMatchType(id, "fatherName"),
          "Mobile Number": getMatchType(id, "mobile"),
          "Lat-Long": getMatchType(id, "location"),
          Address: getMatchType(id, "address"),
        };
        data.push(row);
      });

      return data;
    };

    const borrowerData = generateData("borrower");
    const coapplicantData = generateData("coapplicant");

    const borrowerSheet = XLSX.utils.json_to_sheet(borrowerData);
    const coapplicantSheet = XLSX.utils.json_to_sheet(coapplicantData);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, borrowerSheet, "Applicant");
    XLSX.utils.book_append_sheet(workbook, coapplicantSheet, "Co-Applicant");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Dedupe-Report.xlsx");
  };

  return (
    <div className="dedupe-form">
      <div className="dedupe-container">
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            gap: "1.5rem",
            marginBottom: "16px",
          }}
        >
          <button
            onClick={handleInitiateDeduped}
            style={{
              marginBottom: "16px",
              padding: "8px 16px",
              backgroundColor: "#034ea1",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            disabled={isDisbursed}
          >
            {showButton ? "ReInitiate DeDuped" : "Initiate DeDuped"}
          </button>
          {showButton && (
            <div style={{ fontSize: "14px", color: "#333" }}>
              <strong>Initiated By:</strong> {createdBy} &nbsp; | &nbsp;
              <strong>Date:</strong> {createdDate} &nbsp; | &nbsp;
              <strong>Time:</strong> {createdTime}
            </div>
          )}
        </div>

        {isWaiting && (
          <div style={{ color: "red", margin: "10px 0", fontSize: "1.5rem" }}>
            Please wait, checking for duplicates...
          </div>
        )}

        {/* {showTable && (
                    <table className="dedupe-table">
                        <thead style={{ background: '#f0f0f0' }}>
                            <tr>
                                <th>Criteria</th>
                                <th>Borrower Duplicates</th>
                                <th>Co-applicant Duplicates</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(duplicates).map(([key, values]) => (
                                <tr key={key}>
                                    <td>{readableCriteria[key] || key}</td>
                                    <td>
                                        {Array.isArray(values?.duplicate_borrower_uniquenos) && values.duplicate_borrower_uniquenos.length > 0
                                            ? values.duplicate_borrower_uniquenos.join(', ')
                                            : <em>Not present</em>}
                                    </td>
                                    <td>
                                        {Array.isArray(values?.duplicate_coapplicant_ids) && values.duplicate_coapplicant_ids.length > 0
                                            ? values.duplicate_coapplicant_ids.join(', ')
                                            : <em>Not present</em>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )} */}

        {showTable && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "16px",
              }}
            >
              <div style={{ display: "flex", gap: "1.5rem" }}>
                <button
                  onClick={() => setActiveTable("borrower")}
                  style={{
                    backgroundColor:
                      activeTable === "borrower" ? "#034ea1" : "#eef7ff",
                    color: activeTable === "borrower" ? "white" : "gray",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "1rem",
                    padding: "0.6rem 1.5rem",
                  }}
                >
                  Applicant
                </button>
                <button
                  onClick={() => setActiveTable("coapplicant")}
                  style={{
                    backgroundColor:
                      activeTable === "coapplicant" ? "#034ea1" : "#eef7ff",
                    color: activeTable === "coapplicant" ? "white" : "gray",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "1rem",
                    padding: "0.6rem 1.5rem",
                  }}
                >
                  Co-Applicant
                </button>
              </div>
              <button
                onClick={handleDownloadExcel}
                style={{
                  backgroundColor: "green",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "1rem",
                  padding: "1vh 1vw",
                }}
              >
                Download Excel
              </button>
            </div>

            {activeTable === "borrower" && (
              <>
                <table className="dedupe-table">
                  <thead style={{ background: "#f0f0f0" }}>
                    <tr>
                      <th>Sr No</th>
                      <th>Borrower ID</th>
                      <th>Name</th>
                      <th>Father Name</th>
                      <th>Mobile Number</th>
                      <th>Lat-Long</th>
                      <th>Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const borrowerIds = new Set();
                      [
                        "name",
                        "fatherName",
                        "mobile",
                        "location",
                        "address",
                      ].forEach((field) => {
                        (
                          duplicates[field]?.duplicate_borrower_uniquenos || []
                        ).forEach((id) => borrowerIds.add(id));
                      });

                      return Array.from(borrowerIds).map((id, index) => (
                        <tr key={id}>
                          <td>{index + 1}</td>
                          <td>{id}</td>
                          <td>{getMatchType(id, "name")}</td>
                          <td>{getMatchType(id, "fatherName")}</td>
                          <td>{getMatchType(id, "mobile")}</td>
                          <td>{getMatchType(id, "location")}</td>
                          <td>{getMatchType(id, "address")}</td>
                        </tr>
                      ));
                    })()}
                  </tbody>
                </table>
              </>
            )}

            {activeTable === "coapplicant" && (
              <>
                <table className="dedupe-table">
                  <thead style={{ background: "#f0f0f0" }}>
                    <tr>
                      <th>Sr No</th>
                      <th>Borrower ID</th>
                      <th>Name</th>
                      <th>Father Name</th>
                      <th>Mobile Number</th>
                      <th>Lat-Long</th>
                      <th>Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const coapplicantIds = new Set();
                      [
                        "name",
                        "fatherName",
                        "mobile",
                        "location",
                        "address",
                      ].forEach((field) => {
                        (
                          duplicates[field]?.duplicate_coapplicant_ids || []
                        ).forEach((id) => coapplicantIds.add(id));
                      });

                      return Array.from(coapplicantIds).map((id, index) => (
                        <tr key={id}>
                          <td>{index + 1}</td>
                          <td>{id}</td>
                          <td>{getMatchType(id, "name")}</td>
                          <td>{getMatchType(id, "fatherName")}</td>
                          <td>{getMatchType(id, "mobile")}</td>
                          <td>{getMatchType(id, "location")}</td>
                          <td>{getMatchType(id, "address")}</td>
                        </tr>
                      ));
                    })()}
                  </tbody>
                </table>
              </>
            )}
          </>
        )}
        <ToastContainer />
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={open}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
};

export default Deduped;
